import axios from "utils/axios";
import queryString from "query-string";

export const createWaTag = (payload) => {
  return axios.post("/WA/tags", payload);
};

export const getWaTags = (payload) => {
  return axios.get("/WA/tags", { params: payload });
};

export const deleteWaTag = (id) => {
  return axios.delete(`/WA/tags/${id}`);
};

export const getTags = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/WA/tags?${query}`);
};

export const getTagsCanBeDeleted = () => {
  return axios.get(`/WA/tags/canBeDeleted`);
};

export const updateWaTag = (payload, id) => {
  return axios.put(`/WA/tags/${id}`, payload);
};
